import { logger } from "./logger";
export interface DecodedToken {
  exp?: number;
  iat?: number;
  auth_time?: number;
  jti?: string;
  iss?: string;
  aud?: string;
  sub?: string;
  typ?: string;
  azp?: string;
  sid?: string;
  at_hash?: string;
  acr?: string;
  'Custome-claim'?: {
    orgId?: number;
    orgTypeId?: number;
    roleId?: number;
  };
  ssoToken?: string;
  'sso-method'?: string;
  isTermAndConditionAccepted?: boolean;
  email_verified?: boolean;
  name?: string;
  preferred_username?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
  remember_me?: boolean;
  [key: string]: unknown;
}

//Decodes a JWT token and returns the payload

export const decodeJWT = (token: string): DecodedToken | null => {
  try {
    // JWT tokens have three parts separated by dots: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      logger.error('Invalid JWT token format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    
    const base64 = payload.replaceAll('-', '+').replaceAll('_', '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

    const decoded = atob(padded);
    
    return JSON.parse(decoded) as DecodedToken;
  } catch (error) {
    logger.error('Error decoding JWT token:', error);
    return null;
  }
};


export const getAccessTokenFromStorage = (): string | null => {
  try {
    return localStorage.getItem('access_token');
  } catch (error) {
    logger.error('Error getting access_token from localStorage:', error);
    return null;
  }
};


export const decodeAndLogAccessToken = (): void => {
  try {
    const accessToken = getAccessTokenFromStorage();
    
    if (!accessToken) {
      logger.log('No access_token found in localStorage');
      return;
    }

    const decodedToken = decodeJWT(accessToken);
    
    if (decodedToken) {
      logger.log('Decoded access_token:', decodedToken);
    } else {
      logger.error('Failed to decode access_token');
    }
  } catch (error) {
    logger.error('Error decoding access_token:', error);
  }
};

export const isRememberMeEnabled = (accessToken?: string | null): boolean => {
  const token = accessToken ?? getAccessTokenFromStorage();
  if (!token) {
    return false;
  }

  const decodedToken = decodeJWT(token);
  return decodedToken?.remember_me === true;
};
